import type {ReduxStore} from 'src/reducers';
import IndexStore from 'src/stores';

import * as React from 'react';

import App from './app';
import AppRoutes from 'src/reroutes/app';


export default function SenseApp(props: {
  reduxStore: ReduxStore;
  senseStore: IndexStore;
}) {
  return (
    <App {...props}>
      <AppRoutes {...props} />
    </App>
  );
}
